<template>
    <div>
        <collegeBanner></collegeBanner>
        <div class="container">
            <div class="row">
                <div class="col-md-3">
                    <CollegeSideNavLayout></CollegeSideNavLayout>
                </div>
                <div class="col-md-9">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="fas fa-briefcase"></i>
                                    </div>
                                    <div class="db-stat-count">{{ counts.approved_count }} <span>Approved Internships</span></div>
                                    <div class="db-stat-heading text-capitalize" v-if="counts.pending_count != 0">
                                        <router-link to="/dashboard/view-requested?type=internships" class="text-red">Pending
                                            Internships: {{counts.pending_count}}
                                        </router-link>
                                    </div>
                                    <div class="db-stat-heading text-capitalize text-red" v-if="counts.rejected_count != 0">
                                        Rejected Internships: {{counts.rejected_count}}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="fas fa-users"></i>
                                    </div>
                                    <div class="db-stat-count">{{counts.total_applied_count}} <span>Students Applied</span></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4" v-if="counts.total_hired_count != 0">
                            <div class="db-stat-box">
                                <div class="stat-details">
                                    <div class="db-stat-icon">
                                        <i class="fas fa-users"></i>
                                    </div>
                                    <div class="db-stat-count">{{counts.total_hired_count}} <span>Students Hired</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="dash-inner-box">
                                <div class="dashboard-heading">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <h1>Approved Internships</h1>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="view-all">
                                                <router-link to="/dashboard/all-internships">View All</router-link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row padd-top-10">
                                    <div class="col-md-12" v-if="applications.length">
                                        <div class="col-md-4" v-for="j in applications">
                                            <router-link class="job-box"  :to="{path: '/detail?id=' + j.slug}">
                                                <div class="jb-com-icon">
                                                    <router-link :to="{path: '/profile?slug=' + j.org_slug}">
                                                        <img :src="j.logo" alt="">
                                                    </router-link>
                                                </div>
                                                <div class="jb-com-name">
                                                    <router-link :to="{path: '/profile?slug=' + j.org_slug}">
                                                        <p v-html="j.name"></p>
                                                    </router-link>
                                                </div>
                                                <div class="jb-job-title">
                                                    <span v-html="j.title"></span>
                                                    <div v-if="j.is_exclusive" class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/exclusive.png" width="30" hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Exclusive</span>
                                                    </div>
                                                </div>
                                                <div class="jb-job-positions">
                                                    <router-link :to="{path: '/dashboard/application-processes?id=' + j.slug}" v-if="j.applied_count != 0" class="tooltip-main display-inline-block">
                                                        {{j.applied_count}} Students Applied
                                                        <span class="tooltiptext tooltip-bottom" style="bottom:-45px;">Check Process</span>
                                                    </router-link>
                                                </div>
                                              <span class="stamp is-nope" v-if="j.is_closed">Recruitment Completed</span>
                                                <div class="jb-job-location">
                                                    <i class="fas fa-map-marker-alt"></i> {{j.location}}
                                                </div>
                                                <div class="jb-job-positions">
                                                    <p v-if="j.positions != ''">{{j.positions}} Positions</p>
                                                </div>
                                                <div class="jb-view-details">
                                                    <router-link :to="{path: '/detail?id=' + j.slug}" class="display-inline-block">View Detail
                                                    </router-link>
                                                    <div v-if="j.filling_soon && !j.is_closed" class="tooltip-main labelImg display-inline-block">
                                                        <img src="images/all-jobs/filling-soon.png" width="15" hspace="5"/>
                                                        <span class="tooltiptext tooltip-bottom">Filling Soon</span>
                                                    </div>
<!--                                                    <i class="far fa-copy copy-to-clipboard2" title="Tap to Copy" v-on:click="copyToClipboard($event)"></i>-->
                                                </div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center" v-else>
                                        <img src="images/dashboard/no_data_found.png" class="no-data-found"/>
                                        <h2 class="no-data-found">No Internships Approved Yet</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CollegeSideNavLayout from './../../components/CollegeSideNavLayout.vue'
    import collegeBanner from './../../components/collegeBanner.vue'
    import axios from 'axios'
    import toastr from "../../../public/js/toastr";
    import {requestHeaders} from "../../_helpers/apiHelper";

    export default {
        components: {
            CollegeSideNavLayout,
            collegeBanner
        },
        data: function () {
            return {
                applications: [],
                counts: '',
            }
        },
        mounted() {
            var t = this;
            var url = this.$store.getters.getDomain;

            //api request for new jobs
            axios({
                method: 'POST',
                url: `${url}api/v2/college-profile/approved-jobs`,
                headers: requestHeaders(),
                data: {type:'Internships'}
            }).then(function (res) {
                t.applications = res['data']['response']['jobs'];
                t.counts = res['data']['response']['counts'];
            }).catch(function (error) {
                // console.log(error)
            })
        },
        methods:{
            copyToClipboard(event) {
                var element = event.currentTarget;
                var link = window.location.hostname + element.previousSibling.getAttribute('href');
                var temp = $("<input>");
                $("body").append(temp);
                temp.val(link).select();
                document.execCommand("copy");
                temp.remove();
                toastr.success('Copied to Clipboard', 'Copied');
            },
        }
    }
</script>

<style scoped>
    .tooltip-main .tooltiptext{
        width: auto !Important;
    }
    .jb-job-location > div {
        display: inline-block;
        margin: 0px 2px;
    }
    .copy-to-clipboard2 {
        color: #555;
        cursor: pointer;
        padding: 10px 15px;
        margin: 0px 5px;
        border: 1px solid #ddd;
        border-radius: 10px 0px 10px 0;
    }
    .copy-to-clipboard2:hover{
        border-radius: 0px 0px 0px 0;
        -webkit-transition: .5s all;
        transition: .5s all;
    }
    .job-box{
        display: block;
    }
</style>